import { useState } from 'react'
import {
  Switch,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
  ListItemSecondaryAction,
} from '@material-ui/core'
import { Timer } from '@material-ui/icons'
import PropTypes from 'prop-types'

export const NotifyItem = (props) => {
  const { notifyFromParent, className, callbackFromParentNotify } = props
  const [checkedNotify, setCheckedNotify] = useState(notifyFromParent)

  const handleChange = (name) => (event) => {
    setCheckedNotify(event.target.checked)
    callbackFromParentNotify(event.target.checked)
  }

  const handleLabel = (notifyValue) => {
    if (notifyValue) {
      return 'No Response Links'
    }
    return 'Include Response Links'
  }

  return (
    <div>
      <List className={className}>
        <ListItem>
          <ListItemIcon>
            <Timer />
          </ListItemIcon>
          <ListItemText primary={handleLabel(checkedNotify)} />
          <ListItemSecondaryAction>
            <Switch
              checked={checkedNotify}
              onChange={handleChange('checkedNotify')}
              value="checkedNotify"
            />
          </ListItemSecondaryAction>
        </ListItem>
      </List>
    </div>
  )
}

export default NotifyItem

NotifyItem.propTypes = {
  notifyFromParent: PropTypes.bool.isRequired,
  className: PropTypes.string.isRequired,
  callbackFromParentNotify: PropTypes.func.isRequired,
}
